module.exports = __webpack_public_path__ + "img/benefits-20.3efa6781.svg";